/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";

/**
 *
 * @export
 * @interface CustomPaymentMethodMappingBase
 */
export interface CustomPaymentMethodMappingBaseOptional {
  /**
   *
   * @type {PaymentType}
   * @memberof CustomPaymentMethodMappingBase
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof CustomPaymentMethodMappingBase
   */
  customPaymentMethodId?: string;
}

export interface CustomPaymentMethodMappingBase extends CustomPaymentMethodMappingBaseOptional {
  /**
   *
   * @type {PaymentType}
   * @memberof CustomPaymentMethodMappingBase
   */
  paymentType: PaymentType;
  /**
   *
   * @type {string}
   * @memberof CustomPaymentMethodMappingBase
   */
  customPaymentMethodId: string;
}

export interface CustomPaymentMethodMappingBaseTrackedI {
  /**
   *
   * @type {PaymentType}
   * @memberof CustomPaymentMethodMappingBase
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CustomPaymentMethodMappingBase
   */
  customPaymentMethodId?: string;
  customPaymentMethodIdIsSet: boolean;
}

transformDatesMap.set(
  "CustomPaymentMethodMappingBase",
  function (model: CustomPaymentMethodMappingBase) {},
);

export type CustomPaymentMethodMappingBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  customPaymentMethodId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CustomPaymentMethodMappingBaseMeta: CustomPaymentMethodMappingBaseMetaI =
  {} as CustomPaymentMethodMappingBaseMetaI;
CustomPaymentMethodMappingBaseMeta = typeMeta(
  "CustomPaymentMethodMappingBase",
  {
    paymentType: propertyMeta(
      "paymentType",
      false,
      true,
      false,
      PaymentTypeMeta,
    ),
    customPaymentMethodId: propertyMeta(
      "customPaymentMethodId",
      false,
      true,
      false,
      MetaTypesBase.string,
    ),
  },
);

const metaI = CustomPaymentMethodMappingBaseMeta;

registerMeta(() => {});

export class CustomPaymentMethodMappingBaseTracked implements CustomPaymentMethodMappingBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  customPaymentMethodId__I?: string = undefined;
  customPaymentMethodIdIsSet: boolean = false;
  set customPaymentMethodId(v: undefined | string) {
    if (v !== undefined) {
      this.customPaymentMethodId__I = v;
      this.customPaymentMethodIdIsSet = true;
    } else {
      this.customPaymentMethodId__I = v || undefined;
      this.customPaymentMethodIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get customPaymentMethodId() {
    return this.customPaymentMethodId__I;
  }
  constructor(
    config?: CustomPaymentMethodMappingBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CustomPaymentMethodMappingBaseOptional,
    options?: AssignOptions,
  ): CustomPaymentMethodMappingBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.customPaymentMethodId &&
      this.customPaymentMethodIdApplyFilter(optionsRequired.filter)
    ) {
      this.customPaymentMethodId = config.customPaymentMethodId;
      if (optionsRequired.unassign) this.customPaymentMethodIdIsSet = false;
      else this.customPaymentMethodIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CustomPaymentMethodMappingBaseTrackedI {
    const cloned = {} as CustomPaymentMethodMappingBaseTrackedI;
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.customPaymentMethodIdIsSetDeep() &&
      this.customPaymentMethodIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.customPaymentMethodIdIsSet = true;
      cloned.customPaymentMethodId = this.customPaymentMethodId;
    } else {
      //cloned.customPaymentMethodIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CustomPaymentMethodMappingBaseTrackedI {
    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.customPaymentMethodIdApplyFilter(filter))
      this.customPaymentMethodIdIsSet = false;

    return this;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CustomPaymentMethodMappingBaseMeta.paymentType,
      CustomPaymentMethodMappingBaseMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  customPaymentMethodIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CustomPaymentMethodMappingBaseMeta.customPaymentMethodId,
      CustomPaymentMethodMappingBaseMeta,
      this.customPaymentMethodId,
      this,
    );
  }
  customPaymentMethodIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.customPaymentMethodIdIsSet &&
      this.customPaymentMethodIdApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.customPaymentMethodIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
